import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";

export function isPdsr(
  spdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel | LtlPipelineViewModel | undefined
) {
  if (!spdrOrPdsr) {
    return false;
  }
  return "PdsrId" in spdrOrPdsr;
}
